<span class="item clickable" (click)="returnToDashboard()">
  <img
    style="height: 80px; position:absolute; z-index:3; left: 3.2%;"
    id="logo-unity"
    src="./assets/img/logo-unity-20p.png"
    [ngClass]="{ 'logo-hide': isHide }"
    alt="logo"
  />
</span>

<mat-toolbar
  class="u-toolbar mat-elevation-z1"
  [ngClass]="{ 'light-header': theme !== 'dark' }"
>
  <button mat-icon-button (click)="emitToggleMenuEvent()">
    <mat-icon>menu</mat-icon>
  </button>

  <span style="margin-left:3.2%" id="app-name">UNITY</span>
  <span [attr.id]="'env-' + env" class="env" *ngIf="env != 'prod'">{{
    env
  }}</span>

  <span
    id="search-container"
    class="mat-elevation-z1"
    *ngxPermissionsOnly="['VIDEO_CONSULT']"
  >
    <select id="domain-selector" [(ngModel)]="searchType">
      <option value="1">{{
        'CORE.GLOBAL_SEARCH.DOMAIN_OPTION_WORK' | translate
      }}</option>
      <option value="2">{{
        'CORE.GLOBAL_SEARCH.DOMAIN_OPTION_DEAL' | translate
      }}</option>
      <option value="3">{{
        'CORE.GLOBAL_SEARCH.DOMAIN_OPTION_WORK_RECORD' | translate
      }}</option>
      <option value="4">{{
        'CORE.GLOBAL_SEARCH.DOMAIN_OPTION_PRODUCT' | translate
      }}</option>
      <option value="5">{{
        'CORE.GLOBAL_SEARCH.DOMAIN_OPTION_PURCHASE_ORDER' | translate
      }}</option>
    </select>
    <span class="separator"></span>

    <input
      id="primary-search"
      (keyup.enter)="search()"
      style="font-family: 'Open Sans', sans-serif !important; margin-left:10px"
      placeholder="{{ 'CORE.GLOBAL_SEARCH.PLACEHOLDER' | translate }}"
      [(ngModel)]="inputText"
    />

    <span class="separator"></span>
    <i id="search-icon" class="material-icons" (click)="search()">search</i>
  </span>

  <span class="spacer"></span>

  <div class="spacer"
       style="font-size: 16px"
       *ngIf="user && user.secondary"
       fxLayout="row"
       fxLayoutAlign="start center"
       fxLayoutGap="10px"
  >
    <span>{{ 'CORE.CONNECTED_AS' | translate: {userName: user.login + ' - ' + user.firstName + ' ' + user.name}  }}</span>

    <button *ngIf="user.secondary" color="warn" mat-raised-button (click)="stopIdentityTheft()">
          {{'CORE.STOP' | translate}}
    </button>
  </div>

  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button (click)="switchTheme()" mat-menu-item>
      <mat-icon class="menu-icon">toggle_on</mat-icon>
      <span>{{ 'CORE.SWITCH_THEME' | translate }}</span>
    </button>
    <button (click)="navigate('user', '/account/settings')" mat-menu-item>
      <mat-icon class="menu-icon">person</mat-icon>
      <span>{{ 'CORE.MY_ACCOUNT' | translate }}</span>
    </button>
    <mat-divider color="accent"></mat-divider>
    <button (click)="logout()" mat-menu-item>
      <mat-icon class="menu-icon">power_settings_new</mat-icon>
      <span>{{ 'CORE.LOG_OUT' | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
